import { Swiper, SwiperSlide } from "swiper/react";
import "./Banner.scss";
import { Autoplay, Navigation } from "swiper";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import { API_BASE_URL } from "configs/AppConfig";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { Link, useNavigate } from "react-router-dom";

function Banner() {
  const direction = useSelector(({ theme }) => theme.direction);

  const currentLocale = useSelector(({ theme }) => theme.locale);
  const navigate = useNavigate();

  // const items = [
  //   {
  //     title: "الموضوع 1",
  //     translation: [{ title: "Subject 1", locale: "en" }],
  //     options: [
  //       { id: 1, label: "فولفو", translation: [{ id: 1, label: "Volvo", locale: "en" }] },
  //       { id: 2, label: "ساب", translation: [{ id: 2, label: "Saab", locale: "en" }] },
  //     ],
  //   },
  //   {
  //     title: "الموضوع 2",
  //     translation: [{ title: "Subject 2", locale: "en" }],
  //     options: [
  //       { id: 3, label: "مرسيدس", translation: [{ id: 3, label: "Mercedes", locale: "en" }] },
  //       { id: 4, label: "أودي", translation: [{ id: 4, label: "Audi", locale: "en" }] },
  //     ],
  //   },
  //   {
  //     title: "الموضوع 3",
  //     translation: [{ title: "Subject 3", locale: "en" }],
  //     options: [
  //       { id: 5, label: "بي واي دي", translation: [{ id: 5, label: "BYD", locale: "en" }] },
  //       { id: 6, label: "فيات", translation: [{ id: 6, label: "Fiat", locale: "en" }] },
  //     ],
  //   },
  // ];

  const getBannerData = useSWR({
    url: END_POINTS.API_SLIDER,
  });
  const onChange = (e) => {
    const { value } = e.target;
    navigate(`/subject/search/${value}`);
  };
  const generateSliders = () => {
    if (
      getBannerData.data &&
      !getBannerData.isLoading &&
      !getBannerData.error &&
      getBannerData?.data?.data?.length <= 0
    ) {
      return <div></div>;
    } else if (
      getBannerData.data &&
      !getBannerData.isLoading &&
      !getBannerData.error
    ) {
      const sliders = getBannerData?.data?.data?.map(
        ({ title, description, image, id, link, isInternal, sliderTranslations }) => {
          return (
            <SwiperSlide key={id}>
              <img
                loading="lazy"
                className="d-block w-100 img-slid"
                src={API_BASE_URL + image}
                alt={LabelLangString({
                  id: "title",
                  currentLocale: currentLocale,
                  defaultValue: title,
                  translations: sliderTranslations,
                })}
              />
              <div className={`slider-overlay ${direction}`}>
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-lg-8">
                      {link && (
                        isInternal ? (
                          <Link to={`../${link}`} className="slider-content">
                            <h1 style={{ color: "white"}}>
                              <LabelLang
                                id="title"
                                defaultValue={title}
                                translations={sliderTranslations}
                                cursor="pointer"
                              />
                            </h1>
                            <p>
                              <LabelLang
                                id="description"
                                defaultValue={description}
                                translations={sliderTranslations}
                                cursor="pointer"
                              />
                            </p>
                          </Link>
                        ) : (
                        <a href={link} target="_blank" rel="noreferrer" className="slider-content">
                          <h1 style={{ color: "white"}}>
                            <LabelLang
                              id="title"
                              defaultValue={title}
                              translations={sliderTranslations}
                              cursor="pointer"
                            />
                          </h1>
                          <p>
                            <p>
                              <LabelLang
                                id="description"
                                defaultValue={description}
                                translations={sliderTranslations}
                                cursor="pointer"
                              />
                            </p>
                          </p>
                        </a>
                      ))}
                      {!link && (
                        <div className="slider-content">
                          <h1 style={{ color: "white" }}>
                            <LabelLang
                              id="title"
                              defaultValue={title}
                              translations={sliderTranslations}
                            />
                          </h1>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        }
      );
      return sliders;
    }
    return <></>;
  };

  const subjectsFetching = useSWR({
    url: END_POINTS.SUBJECTS,
  });

  const subjectRendering = (title, translations) => {
    const subject = LabelLangString({
      id: "title",
      currentLocale: currentLocale,
      defaultValue: title,
      translations: translations,
    });
    return subject;
  };

  const renderDataCard = () => {
    const subjectData =
      subjectsFetching.error ||
      subjectsFetching.isLoading ||
      subjectsFetching.data === undefined
        ? []
        : subjectsFetching.data.data;
    const rendering =
      Object.keys(subjectData).length > 0 ? (
        <>
          <option value={0}>
            <FormattedMessage id="choose-topic" />
          </option>
          {subjectData.map(({ title, subSubjects, subjectTranslations }, i) => (
            <optgroup
              key={i}
              label={subjectRendering(title, subjectTranslations)}
            >
              {subSubjects.map(({ title, subjectTranslations, id }, i) => (
                <option
                  key={i}
                  value={id}
                  title={LabelLangString({
                    id: "title",
                    currentLocale: currentLocale,
                    defaultValue: title,
                    translations: subjectTranslations,
                  })}
                >
                  <LabelLang
                    id={"title"}
                    defaultValue={title}
                    translations={subjectTranslations}
                  />
                </option>
              ))}
            </optgroup>
          ))}
        </>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  return (
    <div className="banner">
      <Swiper
        key={direction}
        navigation={true}
        loop={true}
        autoplay={{
          delay: 20000,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
        className={`mySwiper ${direction === "rtl" ? "r-dir" : "l-dir"}`}
      >
        {generateSliders()}
      </Swiper>

      <div className="form-search-over">
        <div className="container pt-5">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="banner__info-form">
                <div className="row" style={{ width: "100%" }}>
                  <div className="col-12 col-lg-4">
                    <label style={{ fontWeight: "bold" }}>
                      <FormattedMessage id="browse" />
                    </label>
                  </div>
                  <div className="col-12 col-lg-8">
                    <div className="dropdown">
                      <select onChange={onChange}>{renderDataCard()}</select>
                      <div className="dropdown-icon" />
                    </div>
                  </div>
                </div>
                <br></br>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
